// The letters an avatar shows when it has no image: the user's in the header,
// the organisation's on a card. One rule for both.

/** The letters of the avatar: the first of the first and of the last word of the name («M. Rossi» is MR); one word gives two. */
export function initialsOf(name: string): string {
  const words = name.split(/[^\p{L}\p{N}]+/u).filter((w) => w !== "");
  const first = words[0];
  if (first === undefined) return "?";
  const last = words[words.length - 1] ?? first;
  const letters = words.length > 1 ? `${[...first][0] ?? ""}${[...last][0] ?? ""}` : [...first].slice(0, 2).join("");
  return letters.toLocaleUpperCase("it-IT");
}
